module.exports = __webpack_public_path__ + "static/assets/a318b0c2bc41661e56b5dbb614ccd0f5.png";